<template>
  <div class="index bg-fff">
    <!-- 导航 -->
    <ao-nav navName='index'></ao-nav>
    <div class="relative">
      <div class="absolute svg-img1">
        <img src="@/assets/new3/home_iphone2.da1b154c.png" alt="" />
      </div>
      <div class="absolute svg-img2">
        <img src="@/assets/new3/home_iphone1.b28f3fe0.png" alt="" />
      </div>
    </div>
    <div class="p-lr-188">
       <div class="p-t-40 relative">
         <div class="font-70 p-b-79 w-full70 wow fadeInUp animated" style="font-weight: bold;">{{$t('langNew2.zzjptgmnr')}}</div>
        <div class="flex p-b-79 wow fadeInUp animated" style="z-index: 999999;">
          <a class="a-hover" @mouseover="showhover(1)" @mouseout="hidehover" v-show="android_link" :href="android_link" title="Android" target="_blank">
            <div class="android-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000">
              <div class="">
                <img class="icon-mobile-hide w-43 h-43" src="@/assets/new3/anzhuo.png" />
                <img class="icon-mobile-show w-43 h-43" src="@/assets/new3/anzhuo-white.png" />
              </div>
              <div class="p-l-10">
                <div class="c-000 font-14">Google Play</div>
                <!-- <div class="c-000 font-14">{{ $t('langNew2.djxz')}}</div>
                <div class="c-000 font-14">{{ $t('langNew2.azsc')}}</div> -->
              </div>
            </div>
          </a>

          <a class="a-hover" @mouseover="showhover(2)" @mouseout="hidehover" v-show="tf_link" :href="tf_link" title="IPhone(Testflight)" target="_blank">
            <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
              <div class="">
                <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
              </div>
              <div class="p-l-10">
                <div class="c-000 font-14">IOS App Store</div>
                <!-- <div class="c-000 font-14">{{ $t('langNew2.djxz')}}</div>
                <div class="c-000 font-14">{{ $t('langNew2.pgsd')}}</div> -->
              </div>
            </div>

          </a>

          <a class="a-hover" @mouseover="showhover(3)" @mouseout="hidehover" v-show="ios_link" :href="ios_link" title="IPhone(Signature)" target="_blank">
            <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
              <div class="">
                <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
              </div>
              <div class="p-l-10">
                <div class="c-000 font-14">iOS App Store</div>
                 <!-- <div class="c-000 font-14">{{ $t('langNew2.djxz')}}</div>
                <div class="c-000 font-14">{{ $t('langNew2.pgsd')}}</div> -->
              </div>
            </div>

          </a>

          <a class="a-hover" @mouseover="showhover(4)" @mouseout="hidehover" v-show="ios_link_2" :href="ios_link_2" title="" target="_blank">
            <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
              <div class="">
                <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
              </div>
              <div class="p-l-10">
                <div class="c-000 font-14">iOS App Store</div>
                <!-- <div class="c-000 font-14">{{ $t('langNew2.djxz')}}</div>
                <div class="c-000 font-14">{{ $t('langNew2.pgsd')}}</div> -->
              </div>
            </div>

          </a>

          <a class="a-hover" @mouseover="showhover(5)" @mouseout="hidehover" v-show="ios_current_link" :href="ios_current_link" title="IPhone(Signature)" target="_blank">
            <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
              <div class="">
                <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
              </div>
              <div class="p-l-10">
                <div class="c-000 font-14">iOS App Store</div>
                <!-- <div class="c-000 font-14">{{ $t('langNew2.azsc')}}</div>
                <div class="c-000 font-14">{{ $t('langNew2.pgsd')}}</div> -->
              </div>
            </div>

          </a>
        </div>

        <div class="qr-android" style="z-index: 99999;" v-show="hover == 1">
          <qriously :value="android_link" :size="128"/>
        </div>
        <div class="qr-ios" style="z-index: 99999;" v-show="hover == 2">
          <qriously :value="tf_link" :size="128"/>
        </div>
        <div class="qr-ios" style="z-index: 99999;" v-show="hover == 3">
          <qriously :value="ios_link" :size="128"/>
        </div>
        <div class="qr-ios" style="z-index: 99999;" v-show="hover == 4">
          <qriously :value="ios_link_2" :size="128"/>
        </div>
        <div class="qr-ios" style="z-index: 99999;" v-show="hover == 5">
          <qriously :value="ios_current_link" :size="128"/>
        </div>

        <div class="wow fadeInUp animated" data-wow-delay=".5s">
          <div class="p-b-124">
            <div class="p-b-20">
              <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
              <span class="font-40 c-000">{{$t('langNew2.yy')}}</span>
            </div>
            <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.pqnr')}}</div>
          </div>
          <div class="p-b-124">
            <div class="p-b-20">
              <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
              <span class="font-40 c-000">{{$t('langNew2.jiami')}}</span>
            </div>
            <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.tgnr')}}</div>
          </div>
        </div>
       </div>

       <div class="flex row-a relative h-366 bg-fff c-000 shadow m-b-100 br-30 z-1 wow fadeInUp animated"  data-wow-delay=".5s" >
         <div class="flex-content col">
           <div class="font-70 p-b-20">$3.8 B</div>
           <div class="font-26 c-707070">{{$t('langNew2.jyl')}}</div>
         </div>
         <div class="flex-content col">
           <div class="font-70 p-b-20">350+</div>
           <div class="font-26 c-707070">{{$t('langNew2.ssjmhb')}}</div>
         </div>
         <div class="flex-content col">
           <div class="font-70 p-b-20">1.2 M</div>
           <div class="font-26 c-707070">{{$t('langNew2.zchy')}}</div>
         </div>
       </div>
       <div class="wow fadeInUp animated"  data-wow-delay=".5s" >
         <div class="flex-b m-b-30">
           <div class="flex-content col bg-img1 br-30 w-790 h-239 cursor" @click="showNew">
             <div class="p-b-20">
              <img class="icon1" src="@/assets/new3/jiantou1@2x.png" alt="" />
             </div>
             <div class="font-34 c-fff p-b-20">
                {{$t('index.xgnysx')}}
             </div>
             <div class="font-18 c-9a9a9a p-lr-30">
                {{$t('index.hyld')}}
             </div>
           </div>
           <div class="flex-content col bg-fff br-30 w-790 h-239 b-1-9a9a9a cursor" @click="mnzh" v-show="temp_user">
             <div class="p-b-20">
              <img class="icon2" src="@/assets/new3/monijiaoyi@2x.png" alt="" />
             </div>
             <div class="font-34 c-000" v-if="!isMn">
                {{ $t('index.symncz')}}
             </div>
             <div class="font-34 c-000" v-else>
                {{$t('login.tcmnzh')}}
             </div>
           </div>
         </div>
         <div class="flex-b">
           <div class="flex-content bg-img2 br-30 col w-387 h-314 cursor">
             <div class="video-box">
               <video id="video" class="w-387 h-314" width="100%" height="314" controls :src="videoUrl">
                <source />
              </video>
              <img class="video-bg w-387 h-314 cursor" v-show="isVideoBg" src="@/assets/new3/shiping.png" @click="playVideo" alt="" />
             </div>
           </div>
           <div class="flex-content bg-img2 br-30 col w-387 h-314 relative p-b-20">
             <div>
              <img class="icon3" src="@/assets/new3/hangqing_light_icon@2x.png" alt="" />
             </div>
             <div class="font-16 c-9a9a9a p-b-20">
              {{$t('index.zdjyfy')}}
             </div>
             <div class="font-24 c-fff p-lr-20">
              {{$t('index.jysyzc')}}
             </div>
             <div class="font-16 c-9a9a9a p-20">
              {{$t('index.hbsp')}}
             </div>
             <div class="flex-content font-16 c-000 br-20 bg-fff w-137 h-46 cursor absolute" style="bottom:.2rem" @click="jump('/market')">
              {{ $t('index.ksjy')}}
             </div>
           </div>
           <div class="flex-content bg-img2 br-30 col w-387 h-314 relative p-b-20">
             <div>
              <img class="icon4" src="@/assets/new3/AIzhuanbi@2x.png" alt="" />
             </div>
             <div class="font-16 c-9a9a9a p-b-20">
              {{ $t('index.jdewd')}}
             </div>
             <div class="font-24 c-fff p-lr-20">
              {{ $t('index.aizb')}}
             </div>
             <div class="font-16 c-9a9a9a p-20">
              {{ $t('index.srjh')}}
             </div>
             <div class="flex-content font-16 c-000 br-20 bg-fff w-137 h-46 cursor absolute" style="bottom:.2rem" @click="jump('/ai')">
              {{ $t('index.ksjy')}}
             </div>
           </div>

           <div class="flex-content bg-img2 br-30 col w-387 h-314 relative p-b-20">
             <div>
              <img class="icon5" src="@/assets/new3/daibi_light_icon@2x.png" alt="" />
             </div>
             <div class="font-16 c-9a9a9a p-b-20">
               {{ $t('index.dlyhggdje')}}
             </div>
             <div class="font-24 c-fff p-lr-20">
               {{ $t('index.jmhbdk')}}
             </div>
             <div class="font-16 c-9a9a9a p-20">
              {{ $t('index.zmyrhdyp')}}
             </div>
             <div class="flex-content font-16 c-000 br-20 bg-fff w-137 h-46 cursor absolute" style="bottom:.2rem" @click="jump('/currency')">
              {{ $t('index.ksjy')}}
             </div>
           </div>


         </div>
       </div>
      <!-- 交易品种市场趋势 -->
      <div>
        <!-- tab -->
        <div class="box03 ov wow fadeInUp animated p-b-60" data-wow-delay=".5s">
          <div class="box ov">
                <div class="tabox ov">
                    <div class="cont ov" style=" display:block;">
                        <div class="th">
                            <div class="td td2 t-left">{{$t('hq.mc')}}</div>
                            <div class="td td1">{{$t('hq.xs')}}</div>
                            <div class="td td1">{{$t('hq.tb')}}</div>
                            <div class="td td1">{{$t('hq.jg')}}</div>
                        </div>
                        <div class="tr bg-000 m-b-20" v-for="(item, index) in usdtList" :key="index+'a'" @click="goPage(item.symbol,item.type,item.id,item.name)">
                          <div class="td td2 t-left"><img :src="item.icon">{{ item.currency | rewriteName}}/USDT</div>
                          <div class="td td1"><span :class="[item.grow < 0 ? 'red':'green']">{{ item.grow > 0 ? '+':'' }}{{ item.grow }}%</span></div>
                          <div class="td td1">
                            <trend
                              :class="item.grow < 0?'fill-red m-t-20':'fill-green m-t-20'"
                              :data="item.klinelist.map(Number)"
                              :gradient="item.grow < 0?['red']:['green']"
                              :width="85"
                              :height="27"
                              auto-draw
                              smooth
                            >
                            </trend>
                          </div>
                          <div class="td td1"><span>{{ item.new_price }}</span> <span class="aaa"></span> <span class="aaa"></span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- 脚部 -->
    <ao-footer></ao-footer>
    <!-- 公告弹窗 -->
    <div class="mask-notice" v-show="isNotice">
      <div class="notice-alert-wrap">
          <div class="title">{{ $t('index.gg') }}</div>
          <div class="cont" v-html="noticeHtml"></div>
          <div class="notice-btn cursor" @click="goDetail">{{ $t('user.ckxq') }}</div>
          <img class="btn-close cursor" @click="noticeClose" src="@/assets/login_delete.png" alt="">
      </div>
    </div>
     <!-- 新功能 -->
    <div class="mask-notice cursor" v-show="isNew" @click="close2">
      <div class="new-box w-990 bg-fff">
        <div class="new-head">
          <img class="new-close" src="@/assets/new3/fanhui@2x.png" alt="">
          <div class="new-tips c-000 font-40">{{$t('zb.ts')}}</div>
        </div>
        <div class="new-title w-680 c-000 font-40 t-center">{{$t('index.xgnysx')}}</div>
        <div class="new-cont w-680 c-000 font-32 t-center">{{$t('index.hyld')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AoNav from "@/components/AoNav";
import AoFooter from "@/components/AoFooter";
// import areaChart from '@/components/areaChart.vue'
import pic from '@/utils/pic'
import { setToken, removeToken } from '@/utils/auth'
import { marke_price,number_round } from '@/utils/index'
import { getGG, getmarketList, getBanner, getQrcode,getParam,getText,getCheckcode } from "@/api/index";
var index_timer = null;
// let intervalId = null;
import iconLeft from "@/assets/icon-left.png";
import iconRight from "@/assets/icon-right.png";
import iconRightHome from "@/assets/Home_banner_icon.png";
import zheXian from "@/assets/zhexian.png";
import { mapGetters } from "vuex";
let vm = null;
export default {
  components: {
    AoNav,
    AoFooter
  },
  data() {
    return {
      //shortTickers: [{coin: "ETC",quoteUnit: "USDT"},{coin: "XIL",quoteUnit: "USDT"},{coin: "FIL",quoteUnit: "USDT"},{coin: "DOGE",quoteUnit: "USDT"}], // 顶部四个交易对
      iconbg: pic.iconbg,
      indexphone: pic.indexphone,
      bannerList: [],
      usdtList: [],
      oldList: [],
      noticeList: [],
      index: 0,
      value: '',
      dealsIndex: 0,
      tabIndex: 0,

      // featureTitle2: this.$t("index.featureTitle2"),
      // featureMsg2: this.$t("index.featureMsg2"),

      iconLeft:iconLeft,
      iconRight: iconRight,
      iconRightHome: iconRightHome,
      zheXian: zheXian,
      iconDirection: 1,
      lClass: '',
      rClass: '',
      type: 'text',
      swiper: null,
      qrcode: {},
      currencyList: [],
      android_link: "",
      ios_link: "",
      tf_link: "",
      ios_link_2: "",
      ios_current_link: "",
      isNotice: false,
      noticeId: '',
      noticeHtml: '',
      isNoticeShow: '',
      lang: 'en',
      bzType: 1,
      trendArr:[],//分时图数组
      temp_user: false,
      isNew: false,//新功能弹窗
      isVideoBg: true,//视频背景
      videoUrl: '',
      userInfo: {},//真实用户信息
      userInfoDemo: {},//模拟用户信息
      isMn: false,
      hover:0,
      token:null,
    };
  },
  // computed: {
  //   ...mapGetters(["token"])
  // },
  created(){
    vm = this;
    this.token = localStorage.getItem('token') || '';
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'en';
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userInfoDemo = JSON.parse(localStorage.getItem('userInfoDemo'));
    this.isMn = JSON.parse(localStorage.getItem('isMn')) || false;
    getBanner().then(res => {
      this.bannerList = res;
      setTimeout(() => {
        this.swiper = new Swiper('.swiper-container',{
            direction: 'vertical', // 垂直切换选项
            // height: 'auto',
            slidesPerView: 1,
            // spaceBetween: 30,
            autoplay:true,
            loop: true,
            // observer:true,  //修改swiper自己或子元素时，自动初始化swiper
            // observeParents:true,  //修改swiper的父元素时，自动初始化swiper
            autoplay: {
                delay: 2000,
                disableOnInteraction: false
            },
            pagination: {
              el: '.swiper-pagination',
              // type: 'custom',
              // type: 'fraction',
              clickable: true,
              renderBullet: function (index, className) {
                return '<span style="width:.5rem;height:.5rem;line-height: .5rem;" class="' + className + '">' + (index + 1) + "</span>";
              }
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
                // click: ()=>{
                //     let swiper = this.$refs.mySwiper.$swiper;
                //     let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
                //     vm.bannerLink(i);
                // }
            },
        })
        // 旧版的横向轮播
        // this.swiper = new Swiper('.swiper-container',{
        //     slidesPerView: 3,
        //     spaceBetween: 30,
        //     autoplay:true,
        //     loop: true,
        //     observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        //     observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        //     autoplay: {
        //         delay: 3000,
        //         disableOnInteraction: false
        //     },
        //     pagination: {
        //       el: '.swiper-pagination',
        //       clickable: true,
        //     },
        //     on:{
        //         click: ()=>{
        //             let swiper = this.$refs.mySwiper.$swiper;
        //             let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
        //             vm.bannerLink(i);
        //         }
        //     },
        // })
      }, 0)
    })
    getGG().then(res => {
      var noticeArr = [];
      this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      this.noticeList = res;

      if(res.length > 0){
        noticeArr = res.filter((item,index) =>{
					if(item.is_popover == 1){
						return true;
					}else{
						return ''
					}
				});
				if(noticeArr.length > 0){
					if(this.isNoticeShow){
						this.isNotice = false;
					}else{
						this.isNotice = true;
					}
					this.noticeId = noticeArr[0].id;
					this.getDetail(this.noticeId);
				}
			}else{
				this.isNotice = false
			}
    });
    getQrcode().then(res => {
      this.qrcode = res
    });
    getParam().then(res => {
      for(var i=0;i< res.length; i++){
        if(res[i].key == 'android_link'){
          this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_link'){
          this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'tf_link'){
          this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'online_service'){
          localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'online_service2'){
          localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'ios_link_2'){
          this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_current_link'){
          this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'tb_eth_video_link'){
          this.videoUrl = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }
      }
    });
    this.getmarketList();
    this.getSimulation();
    this.initWebSocket();
    let that = this;
    if(window.GLOBAL.is_sw_market){
      __socket.emit("index", 'index');
      __socket.on("daymarket", msg => {
        if (typeof msg === 'string') msg = JSON.parse(msg)
        if (msg.type == "daymarket") {
          //tabIndex 0=主流币 1=涨幅币
          var arr = this.usdtList.concat([])
          arr.forEach(o => {
            if (o.symbol == msg.symbol) {
              o.grow = number_round(msg.change, window.GLOBAL.NUMBER_ROUND_2)
              o.vol = number_round(msg.volume)
              o.new_price = number_round(marke_price(msg.now_price, o.is_control,o.buy_control_value,o.risk_value))
            }
          })
          if(this.tabIndex==1){
            this.sort(arr)
          }else{
            this.usdtList = arr
          }
        }
      });
    }

    this.$nextTick(() => {
      new this.$wow.WOW({resetAnimation: false,live: false }).init()
    })
  },
  destroyed() {
    index_timer&&clearInterval(index_timer);
  },
  methods: {
    showhover(e){
      this.hover = e
    },
    hidehover(){
      this.hover = 0
    },
    mnzh(){
      console.log(!this.isMn)
      if(!this.isMn){
        this.createSimulation()
      }else{
        this.exit()
      }
    },
    playVideo(){
      this.isVideoBg = false;
      const video = this.$el.querySelector('video');
      if (video) {
        video.play();
      }
    },
    showNew(){
      this.isNew = !this.isNew;
    },
    close2(){
      this.isNew = false;
    },
    exit(){
      // console.log(this.userInfoDemo)
      // console.log(this.userInfoDemo.token)
      removeToken(this.userInfoDemo.token);
      localStorage.removeItem('isMn');
      localStorage.removeItem('userInfoDemo');
      if(this.userInfo){
        this.isMn = false;
        setToken(this.userInfo.token);
        localStorage.setItem('token',this.userInfo.token);
      }else{
        this.isMn = false;
        this.$router.push('/index')
      }
      window.location.reload();
    },
    goPage(symbol,type,id,bz){
      this.$router.push({ path: '/trade', query: { symbol: symbol,bzType: type,bzId: id,bz: bz } })
    },
    getSimulation(){
      getCheckcode().then(res => {
        if(typeof res === 'string') res = JSON.parse(res);
        this.temp_user = res.temp_user;
      });
    },
    createSimulation(){
      if(this.userInfoDemo){
        this.isMn = true;
        setToken(this.userInfoDemo.token);
        localStorage.setItem('token',this.userInfoDemo.token);
        localStorage.setItem('isMn',JSON.stringify(true));
        this.$router.push('/index');
        window.location.reload();
      }else{
        this.$store.dispatch('login2', {}).then((res) => {
          this.isMn = true;
          localStorage.setItem('token',res.token)
          localStorage.setItem('isMn',JSON.stringify(true));
          localStorage.setItem('userInfoDemo',JSON.stringify(res));
          this.$message({
            type: "",
            message: this.$t('login.cjmnzhcg')
          });
          setTimeout(() => {
            this.$router.push('/index');
            window.location.reload();
          }, 500)
        // if(this.path_active != '/index'){
        //   localStorage.setItem('isMn',true)
        //   this.$router.push({ path: '/index' })
        // }

      }).catch(() => {}).finally(() => {})
      }
    },
    jump(path){
      if(path=='/deal_c'){
        localStorage.setItem('type',2)
      }
      if(path=='/deal'){
        localStorage.setItem('type',1)
      }
      if(path=='/deal_jg'){
        localStorage.setItem('type',3)
      }
      if(path=='/preciousMetal'){
        localStorage.setItem('type',2)
      }
      if(path=='/contractTransaction'){
        localStorage.setItem('type',3)
      }
      this.$router.push({ path: path });
    },
    move() {
      this.lClass = this.iconDirection ? 'l2' : ''
      this.rClass = this.iconDirection ? 'r2' : ''
      this.type = this.iconDirection ? 'card' : ''
      this.iconDirection = ! this.iconDirection
    },
    tab(i,type){
      this.tabIndex = i;
      this.bzType = type;
      this.usdtList = [];
      if(i==3){
        this.sort(this.usdtList.concat([]))
      }else{
        this.getmarketList();
      }
    },
    sort(data) {
      data.sort(function(a,b){
        return Number(a.grow) - Number(b.grow)
      }).reverse();
      this.currencyList = [];
      this.usdtList = data;
      for(var jj in data){
        this.currencyList[this.usdtList[jj].currency] = [this.usdtList[jj].change] ;
      }
    },
    link(a,type) {
      if(type == 1){
        localStorage.setItem('type',3)
        this.$router.push({ path: '/deal_c', query: { symbol: a ,selfType : type} })
      }else{
        localStorage.setItem('type',3)
        this.$router.push({ path: '/contractTransaction', query: { symbol: a,selfType : type } })
      }
    },
    more() {
      this.$router.push({ path: '/market', query: {  } })
    },
    register() {
      this.$router.push({ path: '/register', query: { v: this.value } })
    },
    getmarketList() {
      let that = this;
      let params = {
        id:2,
        type:this.bzType,
        sort:'',
        updown:'',
        limit: 10,
        page: 1,
      }
      getmarketList(params).then(res => {
        this.usdtList = res.data;
        this.oldList = res.data;
        this.currencyList = [];
        // this.usdtList.map(item => {
        //     var newKlineData = this.removeQuotesFromJSON(item.klinelist);
        //     item.klinelist = newKlineData;
        //     return item;
        //   })
        for (var curr in res.data){
          this.currencyList[this.usdtList[curr].currency] = [this.usdtList[curr].change,this.usdtList[curr].symbol];
        }
      });
    },
    // removeQuotesFromJSON(jsonArr) {//去掉数组引号
    //   const regex = /"([^"]+)"/g;
    //   return JSON.parse(JSON.stringify(jsonArr).replace(regex, "$1"));
    // },
    initWebSocket(){ //初始化weosocket
					const wsuri = window.GLOBAL.webSocket;
					this.websock = new WebSocket(wsuri);
					this.websock.onmessage = this.websocketonmessage;
					this.websock.onopen = this.websocketonopen;
					this.websock.onerror = this.websocketonerror;
					this.websock.onclose = this.websocketclose;
				},
				websocketonopen(){ //连接建立之后执行send方法发送数据
					// var msg = {'time_type': vm.timeType,'currency_type':vm.currency_type,'uid': vm.uid};
					// this.websocketsend(JSON.stringify(msg));
				},
				websocketonerror(){//连接建立失败重连
					this.initWebSocket();
				},
				websocketonmessage(e){ //数据接收
         if(JSON.parse(e.data).action == "marketprice"){
           let msg = JSON.parse(e.data).content;
            let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.usdtList){
                x = this.bzType == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.usdtList[y].symbol){
                  this.usdtList[y]['new_price'] = msg[x].now_price;
                  this.usdtList[y]['grow'] = msg[x].change;
                  keyArr.push(this.usdtList[y]);
                  break;
                }
              }
            }
            this.usdtList = keyArr;
         }

				},
				websocketsend(Data){//数据发送
					this.websock.send(Data);
				},
				websocketclose(e){  //关闭
					console.log('断开连接',e);
				},
    bannerLink(i){
      let id = this.bannerList[i].id;
      let content = this.bannerList[i].content;
      if(id){
        if(this.filterHtmlTag(content)){
          this.$router.push({
            path: "/bannerDetail",
            query: { id }
          });
        }
      }
    },
    filterHtmlTag(msg){
      var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
          msg = msg.replace(/[|]*\n/, '') //去除行尾空格
          msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
          return msg;
    },
    notice(id) {
      this.$router.push({
        path: "/notice",
        query: { id }
      });
    },
    getClass(grow) {
      return parseFloat(grow) < 0 ? "down" : "";
    },
    change(index) {
      this.index = index;
    },
    downLoad(){
      this.$router.push('/downLoad');
    },
    goDetail(){
      let id = this.noticeId;
			 this.$router.push({
        path: "/notice",
        query: { id }
      });
		},
    getDetail(id){
      getText({id:id}).then(res => {
        if (res && res.content) {
          this.noticeHtml = res.content;
        }
      })
    },
    noticeClose(){
			if(this.isNoticeShow != null){
				this.isNotice = true;
				sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
		},
  }
};
</script>

<style lang="scss" scoped>
  .qr-android{
    position: absolute;
    top: 45%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 20px;text-align:center;background: #fff
  }
  .qr-ios{
    position: absolute;
    top: 45%;
    left: 15%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 30px;text-align:center;background: #fff
  }
  .svg-img1{
    top: 0;
    right: 0;
  }
  .svg-img1 img{
    width: 6.06rem;
    height: 12.62rem;
    // width: 7.878rem;
    // height: 16.406rem;
  }
  .svg-img2{
    top: 4.2rem;
    right: 2.35rem;
  }
  .svg-img2 img{
    width: 5.65rem;
    height: 8.77rem;
    // width: 7.345rem;
    // height: 11.401rem;
  }
  .bg-img1{
    background-image: url('../assets/new3/backgroup1@2x.png');
    background-size: 100% 100%;
  }
  .bg-img2{
    background-image: url('../assets/new3/backgourp2@2x.png');
    background-size: 100% 100%;
  }
  .icon1{
    width: .43rem;
    height: .42rem;
  }
  .icon2{
    width: .46rem;
    height: .50rem;
  }
  .icon3{
    width: .45rem;
    height: .38rem;
  }
  .icon4{
    width: .45rem;
    height: .42rem;
  }
  .icon5{
    width: .44rem;
    height: .50rem;
  }
  .shadow{
    box-shadow: 0 33px 60px 11px rgba(0, 0, 0, 0.06);
  }

  // .fill-red >>> path {
  //   fill:rgba(255,0,0,0.5);
  // }
  // .fill-green >>> path {
  //   fill:rgba(0,128,0,0.5);
  // }
  .bg-img{
    background-image: url('../assets/home/picture1.png');
    background-size: 100% 100%;
  }
  .bg-hover:hover{
    background-color: #212228;
  }
  .bg-hover:hover .op-hover{
    opacity: 1;
  }
  .input-reg{
    color: #a8a8a8;
    text-indent: .2rem;
  }
  .icon-mobile-show{
    display: none;
  }
  .android-btn:hover{
    background-color: #000;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }
  .ios-btn:hover{
    background-color: #000;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }
  .a-hover{
    // position: relative;
    height: .94rem;
  }
  .a-hover:hover{
    .icon-mobile-show{
      display: block;
    }
  }

.rise {
  text-align: center;
}
.fall {
  text-align: center;
}
.rise span,.fall span{
  display:inline-block;
  width: 83px;
  height: 32px;
  line-height: 32px;
  background: rgba(220, 86, 86, .13);
  border-radius: 2px;
}
.coin-li-head > .rise span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #27af87 !important;
}
.coin-li-head > .fall span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #e05a5a !important;
}

  .box03{ width:100%;}
  .box03 .box{margin:auto;}
  .box03 .title{ float:left; color: #fff;font-size:40px; line-height:50px; font-weight:bold;}
  .box03 .tab_menu{ display:block;}
  .box03 .tab_menu li{ display:block; font-size:.34rem; line-height:.73rem; height:.73rem; border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:30px; color:#9a9a9a; cursor:pointer;}
  .box03 .tab_menu li.cur{ width: 1.6rem;
  	height: .73rem;line-height: .73rem;text-align: center;
  	background-color: #fcd535;
  	border-radius: .1rem;color:#000;}
  .box03 .tabox{ width:100%; float:left; margin-top:30px;}
  .box03 .tabox .cont{ width:100%;}
  .box03 .tabox .cont .th{ width:100%; overflow:hidden; font-size:16px; color:#9a9a9a;}
  .box03 .tabox .cont .td{ float:left; line-height:60px; height:60px;}
  .box03 .tabox .cont .th .td:nth-child(1){ text-align: left;padding-left: .6rem;}
  .box03 .tabox .cont .tr .td:nth-child(1){ text-align: left;padding-left: .6rem;}
  .box03 .tabox .cont .td2{ width:25%; }
  .box03 .tabox .cont .td1{ width:25%;text-align: center; }
  .box03 .tabox .cont .tr{ overflow:hidden; font-size:14px; border-radius:.25rem; color:#fff;}
  .box03 .tabox .cont .tr .td2{ text-align:center; box-sizing:border-box;}
  // .box03 .tabox .cont .tr .td1 a:hover{ color:#00d5fd;}
  .box03 .tabox .cont .td2 img{ width:26px; border-radius:100%; overflow:hidden; height:26px; margin-right:10px; display:block; float:left; margin-top:17px;}
  .red{ color:red;}
  .green{ color:green;}

/*广告*/
  .notice-alert-wrap{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 12;
    width: 400px;
    padding: 0 6px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    transform: translate(-50%,-50%);
  }
  .notice-alert-wrap .title{
    padding: 10px;
    color: #000;
    font-size: 16px;
    text-align: center;
  }
  .notice-alert-wrap .cont{
    min-height: 80px;
    max-height: 400px;
    padding: 10px;
    color: #666;
    font-size: 13px;
    word-break: break-word;
    overflow-y: auto;
  }
  .notice-alert-wrap .notice-btn{
    width: 280px;
    height: 36px;
    margin: 10px auto 20px;
    color: #fff;
    line-height: 36px;
    border-radius: 4px;
    background: #000;
    cursor: pointer;
    text-align: center;
  }
  .notice-alert-wrap .btn-close{
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    cursor: pointer;
  }
//   // 公告
  .notice-wrap{
    width: 100%;
  }
  .notice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    .notice-tips{
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
    .notice-tips .icon{
      width: 24px;
    }
    .notice-new{
      width: .6rem;
      height: .25rem;
      background-color: #fcd535;
      border-radius: .02rem;
    }
    .notice-more{
      color: #fcd535;
      font-size: .144rem;
      cursor: pointer;
    }
    // .notice-more:hover{
    //   color: #fff;
    //   font-size: 1*16/100 rem;
    // }
    .notice-item{
      flex: 1;
    }
    & > .notice-item {
      font-size: .12rem;
      color: #fff;
      overflow: hidden;
      word-break: keep-all;
      text-align: center;
      span {
        display: inline-block;
        position: relative;
        padding: 0 2em 0 1.5em;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #fcd535;
        }
        & + span {
          border-left:1px solid #c8c8c8;
          padding-left:.3rem;
          margin-right: 1.5rem;
          // &::before {
          //   content: "/";
          //   position: absolute;
          //   left: -0.5em;
          //   color: #54748f;
          // }
        }
      }
    }
  }
// .swiper-pagination{
//     width:100%;
//     bottom: -25px;
//     left:0;
//     right:0;
//     margin:auto;
//   }
//   .swiper-pagination-bullet{
//     background: #999;
//     opacity: 1;
//     width: 40px!important;
//     height: 5px!important;
//     border-radius: 4px;
//     margin:0 4px;
//     color: transparent;
//   }
//   .swiper-pagination-bullet-active{
//     background: #0d73f2;
//   }
</style>
<style>
  .absolute .swiper-pagination{
    display: flex;
    left: 1rem;
    top:.65rem
  }
  .absolute .swiper-pagination .swiper-pagination-bullet{
    font-size: .26rem;
    color: #9f9f9f;
    width: .4rem;
    transform-origin: 0 0;
    transform: rotate(-90deg);
    background: transparent;
    opacity: 1;
  }
  .absolute .swiper-pagination .swiper-pagination-bullet-active{
    background: transparent !important;
    font-size: .41rem;
    color: #fff;
  }
  .absolute .swiper-button-prev{
    width: .7rem;
    height: .7rem;
    background-color: #212228;
    border-radius: 10px;
    font-size: .14rem;
    background-image: url(../assets/home/arrow-up.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }
  .absolute .swiper-button-next{
    width: .7rem;
    height: .7rem;
    background-color: #212228;
    border-radius: 10px;
    background-image: url(../assets/home/arrow-down.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }
  .mask-notice{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(0,0,0,.3);
  }
  /* 新功能提示弹窗 */
  .new-box{
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 10;
    padding: .84rem .8rem;
    border-radius: .3rem;
    box-sizing: border-box;
    transform: translate(-50%,-50%);
  }
  .new-box .new-head{
    display: flex;
    align-items: center;
  }
  .new-box .new-close{
    width: .5rem;
    height: .5rem;
    margin-right: .1rem;
  }
  .new-box .new-title{
    padding: .68rem 0 .58rem;
  }
  .video-box,#video{
    position: relative;
    width: 3.87rem;
    height: 3.14rem;
    border-radius: .25rem;
  }
  .video-bg{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    width: 3.87rem;
    height: 3.14rem;
    border-radius: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue